import MicroModal from 'micromodal';
import { BoneModal, closeModal } from './BoneModal';
import { Modals, makeModalConfig } from './modals';

const cartClass = 'mini-cart';
const cartItemClass = 'cart-item';
const sidebarClass = 'sidebar-cart-dev';

const WC_Ajax_Minicart = (() => {

	const wcc = {
		cart: undefined,
		sidebar: undefined,
		sidebarModal: undefined,
		hasAjax: false,
		initialised: false,
	}

	wcc.init = function() {
		const cart = document.querySelector(`.${cartClass}`);
		if (!cart) {
			return;
		}

		wcc.cart = cart;
		wcc.hasAjax = !! Ajax;

		wcc.setupRemoveButtons();
		wcc.setupAddToCartButtons();
		wcc.setupCheckoutButtons();
		wcc.setupUpdateQuanitiesButtons();
		wcc.clearFragmentCache(); // not entirely sure if this is still necessary

		const sidebar = document.getElementById('sidebar-cart');
		if (sidebar) {
			wcc.sidebar = sidebar;

			const modalsSharedContainer = document.querySelector('.modals-shared-container');
			wcc.sidebarModal = new BoneModal(sidebar, {customParent: modalsSharedContainer});
			wcc.initCustomQtyUI();
		}
		wcc.initialised = true;
	}

	wcc.setupRemoveButtons = function() {
		if (!wcc.cart) {
			return;
		}

		wcc.cart.addEventListener('click', wcc._onRequestRemoveFromCart);
	}

	wcc.setupAddToCartButtons = function() {
		if (!wcc.cart) {
			return;
		}

		document.body.addEventListener('click', wcc._onRequestAddToCart);
	}

	wcc.setupCheckoutButtons = function() {
		if (!wcc.cart) {
			return;
		}

		wcc.cart.addEventListener('click', wcc._onProceedToCheckout);
	}

	wcc.setupUpdateQuanitiesButtons = function() {
		if (!wcc.cart) {
			return;
		}

		wcc.cart.addEventListener('click', wcc._onRequestUpdateQuantities);
	}

	wcc.setupCloseTriggers = function() {
		if (!wcc.sidebar) {
			return;
		}

		wcc.sidebar.addEventListener('click', wcc._onRequestCloseModal, {passive: true});
	}

	/**
	 * Clears cache set up by WC cart-fragments.js that prevents latest templates from loading properly
	 */
	wcc.clearFragmentCache = function() {
		const hasSessionStorage = window.sessionStorage && window.sessionStorage.length;

		if (hasSessionStorage) {
			const storage = window.sessionStorage;
			for (let i = 0; i < storage.length; i++) {
				const key = storage.key(i);

				if (
					key.startsWith('wc_cart_hash') ||
					key.startsWith('wc_fragments')
				) {
					storage.removeItem(key);
				}
			}
		}
	}

	wcc._onRequestRemoveFromCart = function(e) {
		const removeTrigger = e.target.closest('.ajax-remove');
		if (!removeTrigger) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		const itemKey = removeTrigger.getAttribute('data-product_key') || undefined;
		if (itemKey) {
			wcc.blockUI();
			$.ajax( {
				type:     'POST',
				url:      '/?wc-ajax=remove_from_cart',
				dataType: 'html',
				data: {
					action: 'remove_from_cart',
					cart_item_key: itemKey,
				},
				success:  function( response ) {
					const fragments = wcc._safeParseFragmentsResponse(response);
					if (fragments) {
						wcc.updateUI(fragments);
						wcc.updateNotice('Removed from bag');
					}
					else {
						wcc.updateNotice('Error - please reload the page', 'error');
					}
				},
				complete: function() {
					wcc.unblockUI();
				},
				error: function(response) {
					console.log({response})
				},
			} );

		}
	}

	wcc._onRequestAddToCart = function(e) {
		const addTrigger = e.target.closest('.single_add_to_cart_button');
		if (!addTrigger) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();


		// get parent form
		const form = addTrigger.closest('form');

		if (!form) {
			// error - alert user
			return;
		}

		// this is all that's required for this endpoint
		const ajaxData = {
			product_id: null,
			quantity: 1,
		}

		const formData = new FormData(form);
		const isVariableProduct = form.hasAttribute('data-product_variations');

		// get quantity from form
		if (formData.has('quantity')) {
			ajaxData.quantity = formData.get('quantity');
		}

		// if variable product, get variation id from form
		if (isVariableProduct) {
			if (formData.has('variation_id')) {
				ajaxData.product_id = formData.get('variation_id');
			}
			else {
				// reject add to cart - variation required
				// TODO: alert user of missing variation
				return;
			}
		}
		// if simple product get id from submit button
		else if (addTrigger.hasAttribute('value')) {
			ajaxData.product_id = addTrigger.getAttribute('value');
		}

		if (ajaxData.product_id) {

			wcc.blockUI();
			wcc.openModal();
			closeModal('customiser-sidebar');

			$.ajax( {
				type:     'POST',
				url:      '/?wc-ajax=add_to_cart',
				dataType: 'html',
				data: ajaxData,
				success:  function( response ) {
					const fragments = wcc._safeParseFragmentsResponse(response);
					if (fragments) {
						wcc.updateUI(fragments);
						wcc.updateNotice('Added to bag');
					}
					else {
						wcc.updateNotice('Error - please reload the page', 'error');
					}
				},
				complete: function() {
					wcc.unblockUI();
				},
				error: function(response) {
					console.log({response})
				},
			} );
		}

		return;
	}

	wcc._onRequestUpdateQuantities = function(e) {
		const updateTrigger = e.target.closest(`.${cartItemClass}__button-update`);
		if (!updateTrigger) {
			// listener likely set on the wrong element
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		if (!wcc.hasAjax) {
			// something very wrong at this point

			return;
		}

		const items = Array.from(wcc.cart.querySelectorAll(`.${cartItemClass}`));
		if (!items.length) {
			return;
		}

		const cartData = {
			items: [],
		}

		// get the quantity form from each cart item and add its entries to cartData.items
		items.forEach(item => {

			const qtyForm = item.querySelector(`.${cartItemClass}__quantity-form`);
			if (qtyForm) {
				const formData = new FormData(qtyForm);

				let entries = Array.from(formData.entries());
				entries = Object.fromEntries(entries);

				if (
					entries.product_id &&
					entries.quantity
				) {
					cartData.items.push(entries);
				}
			}
		})


		// TODO: validate cartData before posting

		if (cartData.items.length) {

			wcc.blockUI();
			$.ajax( {
				type:     'POST',
				url:      Ajax.url,
				dataType: 'html',
				data: {
					action: 'bone_update_cart_quantities',
					data: cartData,
				},
				success:  function( response ) {
					const fragments = wcc._safeParseFragmentsResponse(response);
					if (fragments) {
						wcc.updateUI(fragments);
						wcc.updateNotice('Bag updated');
					}
					else {
						wcc.updateNotice('Error - please reload the page', 'error');
					}
				},
				complete: function() {
					wcc.unblockUI();
				},
				error: function(response) {
					console.log({response})
				},
			} );
		}
	}

	wcc._onProceedToCheckout = function(e) {
		const trigger = e.target.closest('.wc-forward');
		if (!trigger) {
			return;
		}

		wcc.closeModal();

		// const closeButton = wcc.cart.querySelector('[data-global-close]');
		// console.log({closeButton});
		// if (closeButton) {
		// 	closeButton.click();
		// }
	}

	wcc._onRequestCloseModal = function(e) {
		const trigger = e.target.closest(`.${sidebarClass}__close-trigger`);
		if (!trigger) {
			return;
		}

		wcc.closeModal();

		// const closeButton = wcc.cart.querySelector('[data-global-close]');
		// console.log({closeButton});
		// if (closeButton) {
		// 	closeButton.click();
		// }

		// const triggers = Array.from(document.querySelectorAll(`.${sidebarClass}__close-trigger`));
		// if (triggers && triggers.length) {

		// 	triggers.forEach(trigger => {
		// 		trigger.addEventListener('click', wcc.closeModal, {passive: true});
		// 	})
		// }
	}

	wcc.updateUI = function(fragments) {

		if (fragments) {
			Object.entries(fragments).forEach(entry => {
				const [selector, fragment] = entry;
				wcc.updateUIFragment(selector, fragment);
			});
		}

		wcc.updateCartCount();
		// wcc.updateCartTotal();
	}

	wcc.updateUIFragments = function(fragments) {
		if (!fragments) {
			return;
		}

		Object.entries(fragments).forEach(entry => {
			const [selector, fragment] = entry;
			wcc.updateUIFragment(selector, fragment);
		});
	}

	wcc.updateUIFragment = function(selector, fragmentString) {
		const containers = Array.from(document.querySelectorAll(selector));
		if (containers && containers.length) {
			containers.forEach(container => {
				container.innerHTML = fragmentString;
			});
		}
	}

	wcc.updateCartCount = function() {

		const dataElem = document.querySelector('[data-cart-item-count]');
		if (!dataElem) {
			return;
		}

		const count = dataElem.getAttribute('data-cart-item-count');

		if (count === '0' || count) {
			const elems = Array.from(document.querySelectorAll('.header-icon__counter'));
			if (elems.length) {
				requestAnimationFrame(() => {
					elems.forEach(elem => {
						elem.innerHTML = count;
					});
				})
			}
		}
	}

	wcc.updateCartTotal = function() {

		const dataElem = document.querySelector('[data-cart-item-count]');
		if (!dataElem) {
			return;
		}

		const total = dataElem.getAttribute('data-cart-total');
		try {
			const decodedTotal = decodeURIComponent(total);
			if (decodedTotal) {
				const totalDisplay = wcc.cart.querySelector(`.${cartClass}__totals td.total`);
				if (totalDisplay) {
					totalDisplay.innerHTML = decodedTotal;
				}
			}
		}
		catch (error) {
			//
		}
	}

	wcc.blockUI = function() {
		if (wcc.initialised) {
			wcc.cart.setAttribute('disabled', '');
		}
	}

	wcc.unblockUI = function() {
		if (wcc.initialised) {
			wcc.cart.removeAttribute('disabled');
		}
	}

	wcc.updateNotice = function(message, type) {
		message = message || '';
		type = type || 'success';


		const lockupClass = 'sidebar-cart-dev__notice-lockup';
		const lockup = document.querySelector(`.${lockupClass}`);
		if (!lockup) {
			return;
		}

		console.log('updating notice', message)
		const displayElem = lockup.querySelector('.sidebar-cart-dev__notice');
		displayElem.innerHTML = message;
		lockup.classList.remove(`${lockupClass}--hidden`);


		// lockup.classList.add(`.${lockupClass}--${type}`);
	}

	wcc.clearNotice = function() {
		const lockupClass = 'sidebar-cart-dev__notice-lockup';
		const lockup = document.querySelector(`.${lockupClass}`);
		if (!lockup) {
			return;
		}

		const displayElem = lockup.querySelector('.sidebar-cart-dev__notice');
		displayElem.innerHTML = '';
		lockup.classList.add(`${lockupClass}--hidden`);
	}


	/**
	 * Parse fragment ajax response, attempting to avoid errors and work around dirty WC output
	 *
	 * @param {string} response
	 * @returns Object|Array|false
	 */
	wcc._safeParseFragmentsResponse = function(response) {
		if (!response || typeof response !== 'string') {
			return false;
		}

		/**
		 * Find start of fragment JSON. This is not always the start of the string - because WC uses
		 * output buffering to generate the response, PHP notices etc. can sometimes end up preceeding
		 * the actual data.
		 *
		 * The searched-for start of data is hard-coded in the WC template and is unlikely to change.
		 *
		 * This currently doesn't check for dirty input _after_ the data. This case hasn't yet been
		 * encountered but would result in JSON.parse throwing an error.
		 */
		const jsonStart = response.indexOf('{"fragments"');
		if (jsonStart >= 0) {
			const json = response.slice(jsonStart);
			try {
				const data = JSON.parse(json);
				const fragments = data ? data.fragments : false;
				return fragments;
			}
			catch (err) {
				return false;
			}
		}

		return false;
	}

	wcc.openModal = function() {
		if (wcc.sidebarModal) {
			wcc.sidebarModal.open();
		}
	}

	wcc.closeModal = function() {
		if (wcc.sidebarModal) {
			wcc.sidebarModal.close();
			wcc.clearNotice();
		}
	}

	wcc.decrementQty = function (e, qtyInitial, qtyInput, cartItemUpdate) {
		e.stopPropagation();
		e.preventDefault();

		let qtyNew = Number(qtyInput.value);
		qtyNew -= 1;

		qtyInput.value = qtyNew <= 0 ? 1 : qtyNew;

		wcc.checkUpdate(qtyInitial, qtyInput, cartItemUpdate);
	}

	wcc.incrementQty = function (e, qtyInitial, qtyInput, cartItemUpdate) {
		e.stopPropagation();
		e.preventDefault();

		let qtyNew = Number(qtyInput.value);
		qtyNew += 1;

		qtyInput.value = qtyNew;

		wcc.checkUpdate(qtyInitial, qtyInput, cartItemUpdate);
	}

	wcc.checkUpdate = function (qtyInitial, qtyInput, cartItemUpdate) {
		if (qtyInitial != Number(qtyInput.value)) {
			cartItemUpdate.disabled = false;
		} else {
			cartItemUpdate.disabled = true;
		}
	}

	wcc.initCustomQtyUI = function() {
		/**
		 * TODO: this setup doesn't work after the cart is updated and replaced with a new
		 * html fragment. Recommend switching to the click delegate approach used throughout
		 * this module rather than re-initialising after update, as cart-fragments.js may
		 * also replace this html.
		 */
		const qtyPickers = document.querySelectorAll('.mini-cart .qty-picker');

		if (qtyPickers.length) {
			qtyPickers.forEach(qtyPicker => {
				const decrementButton = qtyPicker.querySelector('.qty-picker__decrement');
				const incrementButton = qtyPicker.querySelector('.qty-picker__increment');
				const qtyInput = qtyPicker.querySelector('input.qty-picker__number');
				const cartItemUpdate = qtyPicker.parentNode.querySelector('.cart-item__button-update');

				let qtyInitial = Number(qtyInput.value);

				//Decrease qty
				decrementButton.addEventListener('click', e => { wcc.decrementQty(e, qtyInitial, qtyInput, cartItemUpdate) });

				//Increase qty
				incrementButton.addEventListener('click', e => { wcc.incrementQty(e, qtyInitial, qtyInput, cartItemUpdate) });

				//Update item
				// cartItemUpdate.addEventListener('click', e => { wcc.itemUpdate(e, qtyInput) });
			});
		}
	}

	wcc.unload = function() {

	}

	return wcc;
})();

export default WC_Ajax_Minicart;



// WEBPACK FOOTER //
// ./scripts/modules/wc-ajax-minicart.js